// MODULES APP
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import localeMXN from '@angular/common/locales/es-MX';
import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { SharedModule } from '@shared/shared.module';
// COMPONENTS
import { AppComponent } from './app.component';
// INTERCEPTORS
import { INTERCEPTOR_PROVIDERS_GLOBALS } from '@interceptors/interceptors';
import { CustomRouteReuseStategy } from './core/route-reuse-strategy/route-reuse-strategy';
import { FileSaverModule } from 'ngx-filesaver';

registerLocaleData(localeMXN, 'es-MX');

const MODULES = [
	BrowserModule,
	BrowserAnimationsModule,
	AppRoutingModule,
	SharedModule,
	HttpClientModule,
	FileSaverModule,
];

const COMPONENTS = [
  AppComponent,
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [...MODULES],
  providers: [
    ...INTERCEPTOR_PROVIDERS_GLOBALS,
    { provide: LOCALE_ID, useValue: 'es-MX' },
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
